module.exports = __webpack_public_path__ + "img/a_1.dcb477ec.png";